
import { useState, useCallback } from 'react';
import { OrderProduct } from '../../types/orderTypes';
import { addProductToList, removeProductFromList } from './utils/productOperations';
import { calculateOrderTotal } from './utils/productCalculations';

export const useProductManagement = (
  products: OrderProduct[],
  setProducts: React.Dispatch<React.SetStateAction<OrderProduct[]>>,
  setTotalAmount: React.Dispatch<React.SetStateAction<number>>
) => {
  // Handle add product
  const handleAddProduct = useCallback((product: OrderProduct) => {
    const updatedProducts = addProductToList(products, product);
    setProducts(updatedProducts);
    
    // Update total amount
    const newTotal = calculateOrderTotal(updatedProducts);
    setTotalAmount(newTotal);
  }, [products, setProducts, setTotalAmount]);
  
  // Handle remove product
  const handleRemoveProduct = useCallback((productId: string) => {
    const productToRemove = products.find(product => product.id === productId);
    if (!productToRemove) return;
    
    const updatedProducts = removeProductFromList(products, productId);
    setProducts(updatedProducts);
    
    // Update total amount
    const newTotal = calculateOrderTotal(updatedProducts);
    setTotalAmount(newTotal);
  }, [products, setProducts, setTotalAmount]);

  return {
    handleAddProduct,
    handleRemoveProduct
  };
};
